let commonTel = '+86 20-3482 5061';
// 中文
let zh = {
  // 公共电话
  commonTel,
  //首页
  home: {
    //顶部导航
    nav: {
      0: "首页",
      1: "关于博仕",
      2: "核心产品",
      3: "党建",
      4: "企业动态",
      5: "主要客户",
      6: "联系我们"
    },
    telp:'全国服务热线',
    // 关于博仕
    aboutTitle:"关于博仕",
    about: {
      0: '广州市博仕机电工贸有限公司成立于2002年，厂房占地面积约13000多平方米，凭借“诚信、求实、创新、效益”的经营理念，',
      1: "逐步稳定发展，属高新技术企业。公司经营范围包括：各类塑盖的制造包装设备、PET瓶坯及各类塑瓶相关的设备、精细化工生产设备、通用机械设备、系统工程设计及安装，备品配件等供应。"
    },
    readMore:{
      0:'了解更多'
    },
    telUs:{
      0:"我们在这里",
      1:'电话：'+commonTel,
      2:'传真：020-3482 5018',
      3:'邮箱：570964631@qq.com',
      4:'地址：广州市番禺区南村镇梅山大道南12号',
      5:'扫码右方二维码关注公众号',
      6:'博仕机电 BuchTech'
    }
  },
  // 资讯详情页
  articleDetails:{
    page:{
      0:'上一篇',
      1:'下一篇',
      2:'全国服务热线'
    }
  },
  // 移动端产品分类列表
  productCatalogList:{
    0:'速度',
    1:'了解更多'
  },
  // 产品详情页
  productDetails:{
    0:'价格',
    1:'请向供应商询问产品报价',
    2:'产品介绍',
    3:'产品参数'
  },
  aboutBuchtech:{
    describ:{
      titles:"企业简介",
      contents:{
        0:'博仕公司为塑盖厂提供的设备有：冷却机、理盖机、切环机、折边机、视觉检测机、瓶盖计数装箱机、塑盖测漏组合机、激光打标机、塑盖贴膜机、加垫机、内塞组装机等系列设备。可以完整的为客户提供塑盖生产设备的交钥匙工程服务。',
        1:'博仕为塑瓶厂和PET瓶胚厂提供的设备包括：瓶胚（空瓶）装箱机、翻斗机、RGV小车、瓶坯（空瓶）视觉检测机、理胚机等。',
        2:'博仕为化工行业配套的主要设备包括：粉末包装机、粘胶装箱生产线、输送包装系统等。',
      }
    },
    culture:{
      titles:'博仕状况',
      descs:{
        // 0:'起步',
        0:'现状',
        // 2:'专利',
        // 3:'行业',
        // 4:'技术',
        1:'目标'
      },
      content:{
        // 0:'2002年底从大型国有企业部分转制成立，20人，500平米简陋厂房',
        0:'公司拥有完整的运作体系，从设计→制造→安装调试→售后服务，提供一站式服务。',
        // 2:'国家发明专利11项、实用新型专利9项、著作权4项',
        // 3:'自动包装机械:啤酒、饮料；精细化工；玻璃制造行业；塑盖/塑瓶制品',
        // 4:'各产品技术、质量达到国内领先、国际同步的水平，行业的标杆企业',
        1:'塑盖、塑瓶包装机械的全球优质供应商'
      }
    },
    history:{
      titles:'发展历程',
      contents:{
        0:'将寻求更高的层次特别是成为全球覆盖、塑料机械的高端供应商。',
        1:'博仕发展与壮大,主力产品更加明显,夯实技术、资金实力,使企业具有一定的规模和科技实力。',
        2: "博仕生存与调整市场结构、加强基础管理工作,使企业成功转型。"
      }
    },
    honors:{
      titles:'荣誉资质'
    },
		newculture:{
			titles:"企业文化"
		}
  },
  footerBar:{
    company:"广州市博仕机电工贸有限公司",
    number:"粤ICP备 17154664号"
  }
}

//英文
let en = {
  // 公共电话
  commonTel,
  //首页
  home: {
    //顶部导航
    nav: {
      0: "Home",
      1: "BuchTech",
      2: "Products",
      3: "Party Building",
      4: "Dynamic",
      5: "Our Client",
      6: "Contact"
    },
    telp:'National Service Hotline',
    // 关于博仕
    aboutTitle:"About BuchTech",
    about: {
      0: "Guangzhou BuchTech Electromechanical I&T Co.,Limited founded in 2002.Our factory has 13,000 square meters area.With our business philosophy of ‘Honesty,Practice,Innovation and Benefit’,Our company is a high-tech enterprise.",
      1: "Our major business includes:all kinds of plastic closure manufacturing and packaging equipment, PET preforms and various plastic performs related equipment, fine chemical production equipment, general mechanical equipment, system engineering design and installation, spare parts and other supplies."
    },
    readMore:{
      0:'More'
    },
    telUs:{
      0:"Here we are",
      1: 'Tel: '+commonTel,
      2: 'Fax: 020-3482 5018',
      3: 'email: 570964631@qq.com',
      4: "Address: No.12 Meishan Road, Nancun, Panyu District, Guangzhou, China",
      5:'Subscribe BuchTech',
      6:'Guangzhou BuchTech'
    }
  },
   // 资讯详情页
   articleDetails:{
    page:{
      0:'prev',
      1:'next',
      2:'Hotline'
    }
  },
  // 移动端产品分类列表
  productCatalogList:{
    0:'speed',
    1:'learn more'
  },
  // 产品详情页
  productDetails:{
    0:'price',
    1:'please ask the supplier for product quotation',
    2:'introduce',
    3:'param'
  },
  aboutBuchtech:{
    describ:{
      titles:"Company Profile",
      contents:{
        0:'The equipment provided by BuchTech for the plastic closure factory includes: cooling machine, sorting machine, slitting machine, folding machine, inspection machine, closure counting and packing machine, plastic closure leak detection assembly machine, laser marking machine, sealing machine, liner applicator ,assembly machine and other equipment. It can provide customers with complete engineering services for plastic closure production equipment.',
        1:'The equipment provided by BuchTech for the plastic preforms factory and PET preform factory includes: preform (empty bottle) soft drop machine, dumper, RGV system , preform (empty bottle)  inspection machine, performs sorter, etc.',
        2:'Our main equipment for the chemical industry includes: powder packaging machines, viscose packing production lines, conveyor packaging systems, etc.',
      }
    },
    culture:{
      titles:'BuchTech Status',
      descs:{
        // 0:'Beginning',
        0:'Presentation',
        // 2:'Patent',
        // 3:'Industry',
        // 4:'Technology',
        1:'Target'
      },
      content:{
        // 0:'By the end of 2002, it was partially transformed from a large state-owned enterprise and established, with 20 people and 500 square meters of simple factory buildings',
        0:'The company has a complete operation system, from design to manufacture to installation and debugging to after-sales service, providing one-stop service.',
        // 2:'11 national invention patents, 9 utility model patents and 4 copyrights',
        // 3:'Automatic packaging machinery: beer and beverage; fine chemical industry; glass manufacturing industry; plastic cap / bottle products',
        // 4:'The technology and quality of each product have reached the domestic leading and international synchronous level, and the industry\'s benchmark enterprise',
        1:'Global high quality supplier of plastic cap and plastic bottle packaging machinery'
      }
    },
    history:{
      titles:'MileStone',
      contents:{
        0:'Will seek a higher level, especially to become a global coverage, high-end supplier of plastic machinery.',
        1:'Boshi develops and expands, its main products are more obvious, and its technology and capital strength are strengthened, so that the enterprise has a certain scale and technological strength.',
        2: "Boshi survive and adjust the market structure, strengthen the basic management work, and make the enterprise successfully transform."
      }
    },
    honors:{
      titles:'Certification'
    },
		newculture:{
			titles:"Enterprise culture"
		}
  },
  footerBar:{
    company:"BuchTech GuangZhou",
    number:"Yue ICP B 17154664"
  }
}

export {
  zh,
  en
}




//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 8